export default __webpack_public_path__ + "static/media/pc-header.f0d43000.webp";